import * as React from "react";
import { createPortal } from "react-dom";

export function withPortal<T>(
    mediaQuery: string,
    WrappedComponent: React.ComponentType<T>
): React.ComponentType<T & {
    disablePortal?: boolean;
}> {
    return class PortalHelper extends React.Component<T & {
        disablePortal?: boolean;
    }> {
        private el: Element | null = null;

        public state = {
            found: false,
        };

        public componentDidMount(): void {
            if(typeof document !== "undefined") {
                this.el = document.querySelector(mediaQuery);

                if(this.el) {
                    this.setState({
                        found: true,
                    });
                } else {
                    console.error("Unable to find portal element", mediaQuery);
                }
            }
        }

        public render(): React.ReactNode {
            const { disablePortal, ...props } = this.props;

            if(disablePortal) {
                return <WrappedComponent {...props as T & React.JSX.IntrinsicElements} />;
            }

            if(this.state.found && this.el) {
                return createPortal(
                    <WrappedComponent {...props as T & React.JSX.IntrinsicElements} />,
                    this.el
                );
            }

            return (
                <span className="portal-element-not-found" />
            );
        }
    };
}
